import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

export default new Router({
  // mode: 'history',
  mode: 'hash',
  routes: [
    // {path: '/homepage',name:'homepage', component: resolve => require(['@/components/HomePage'], resolve)},
    // {path: '/dataset',name:'dataset', component: resolve => require(['@/components/Dataset'], resolve),
    //   children: [
    //     {path: 'xenium',name:'xenium',components:{systemMenu:resolve => require(['@/components/Xenium'], resolve) }},
    //     {path: 'nanostring',name:'nanostring',components:{systemMenu:resolve => require(['@/components/Nanostring'], resolve) }},
    //     {path: 'visium',name:'visium',components:{systemMenu:resolve => require(['@/components/VisiumHD'], resolve) }},
    //     {path: 'visiumff',name:'visiumff',components:{systemMenu:resolve => require(['@/components/VisiumHDFF'], resolve) }},
    //     {path: 'stereo',name:'stereo',components:{systemMenu:resolve => require(['@/components/StereoSeq'], resolve) }},
    //     {path: 'rnaseq',name:'rnaseq',components:{systemMenu:resolve => require(['@/components/ScrnaSeq'], resolve) }},
    //     {path: 'visualization',name:'visualization',components:{visualMenu:resolve => require(['@/components/Visualization'], resolve) }},
    //   ]
    // },
    // {path: '/gene',name:'gene', component: resolve => require(['@/components/Gene'], resolve)},
    // {path: '/download',name:'download', component: resolve => require(['@/components/Download'], resolve)},
    // {path: '/documention',name:'documention', component: resolve => require(['@/components/Documention'], resolve)},

    {path: '/homepage',name:'homepage', component: () => import ('../components/HomePage.vue')},
    {path: '/dataset',name:'dataset', component: () => import ('../components/Dataset.vue'),
      children: [
        {path: 'xenium',name:'xenium',components:{systemMenu:() => import ('../components/Xenium.vue') }},
        {path: 'nanostring',name:'nanostring',components:{systemMenu:() => import ('../components/Nanostring.vue') }},
        {path: 'visium',name:'visium',components:{systemMenu:() => import ('../components/VisiumHD.vue') }},
        {path: 'visiumff',name:'visiumff',components:{systemMenu:() => import ('../components/VisiumHDFF.vue')}},
        {path: 'stereo',name:'stereo',components:{systemMenu:() => import ('../components/StereoSeq.vue') }},
        {path: 'rnaseq',name:'rnaseq',components:{systemMenu:() => import ('../components/ScrnaSeq.vue') }},
        {path: 'visualization',name:'visualization',components:{visualMenu:() => import ('../components/Visualization.vue')}},
      ]
    },
    {path: '/gene',name:'gene', component: () => import ('../components/Gene.vue')},
    {path: '/download',name:'download', component: () => import ('../components/Download.vue')},
    {path: '/documention',name:'documention', component: () => import ('../components/Documention.vue')},
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js